/* DeleteAction.js */

"use strict";

const PLAN_NAME_MAX_LENGTH = 60;
const PLAN_NAME_LIST_LENGTH = 10;

class DeleteAction {
    constructor(
        logger,
        gameEditor,
        modalUserFeedback,
        activeView,
        userSession,
        NetworkDiscoveryPlan
    ) {
        this._logger = logger;
        this._gameEditor = gameEditor;
        this._modalUserFeedback = modalUserFeedback;
        this._activeView = activeView;
        this._activeOrgId = userSession.activeOrganization.id;
        this._NetworkDiscoveryPlan = NetworkDiscoveryPlan;
        this._selectedPlanIds = [];
        this._selectedPlanNames = [];

        if (this._activeView && this._activeView.pagingFeed) {
            this._selectedPlanIds = this._activeView.getSelectedPlanIds().selectedRows || [];
        }

        this.run = this.run.bind(this);
    }

    run() {
        if (this._selectedPlanIds.length) {
            this._activeView.pagingFeed
                .waitForRangeIdsUpdated()
                .then(() => {
                    if (this._selectedPlanIds.length <= PLAN_NAME_LIST_LENGTH) {
                        return this._activeView.pagingFeed.getNetworkDiscoveryEntitiesNameById(
                            this._selectedPlanIds
                        );
                    }
                    return Promise.resolve();
                })
                .then((selectedPlanNames) => {
                    this._selectedPlanNames = selectedPlanNames;
                    if (this._selectedPlanIds.length <= PLAN_NAME_LIST_LENGTH) {
                        if (
                            Array.isArray(this._selectedPlanNames) &&
                            this._selectedPlanNames.length > 0
                        ) {
                            let s = this._selectedPlanNames.length > 1 ? "s" : "";
                            this._message =
                                "Are you sure you want to permanently delete the selected plan" +
                                s +
                                "?\n";
                            Object.keys(this._selectedPlanNames).forEach((id) => {
                                let planName = this._selectedPlanNames[id];
                                let shortPlanName =
                                    planName.length > PLAN_NAME_MAX_LENGTH
                                        ? planName.substr(0, PLAN_NAME_MAX_LENGTH) + "…"
                                        : planName;
                                this._message += "\n" + shortPlanName;
                            });
                            return Promise.resolve();
                        } else {
                            return Promise.reject(new Error("Cannot retrieve the selected plans"));
                        }
                    } else {
                        this._message = `Are you sure you want to permanently delete the selected ${this._selectedPlanIds.length} network discovery plans?\n`;
                        return Promise.resolve();
                    }
                })
                .then(() => {
                    return this._gameEditor.runQuickConfirmationActionWorkflow(
                        {
                            message: this._message,
                            title: "Delete",
                            confirmDetails: {
                                text: "Confirm",
                                type: "destructive",
                            },
                            rejectDetails: {
                                text: "Cancel",
                                type: "text",
                            },
                        },
                        () => {
                            let workTarget = {
                                method: "multi",
                                ids: this._selectedPlanIds,
                            };
                            const showProgFunc = (prog) => {
                                this._modalUserFeedback.showLoadingProgress(
                                    `${prog.successCount} of ${prog.targetCount}`
                                );
                            };
                            return this._NetworkDiscoveryPlan
                                .runDeleteNetworkDiscoveryPlansWork(
                                    this._activeOrgId,
                                    workTarget,
                                    {launchAndForget: false},
                                    showProgFunc
                                )
                                .then((workResults) => {
                                    this._NetworkDiscoveryPlan.throwWorkErrors(workResults);
                                    this._activeView.resetSelection();

                                    return Promise.resolve();
                                });
                        }
                    );
                })
                .catch((err) => {
                    this._logger.warn({error: err}, "DeleteAction.run() - Error");
                    return this._modalUserFeedback.displayError({error: {errorMsg: err}});
                });
        } else {
            return Promise.resolve();
        }
    }
}

module.exports = DeleteAction;

DeleteAction.$inject = [
    "$teve.logger",
    "gameEditor.gameEditor",
    "$teve.ui.userFeedback",
    "gameEditor.activeView",
    "$teve.userSession",
    "$teve.entities.NetworkDiscoveryPlan",
];

DeleteAction.$displayDetails = {
    type: "Action",
    name: "DeleteAction",
    icon: "common.trash_bin",
    shown: true,
    title: "Delete Discovery Plan",
    order: 7,
};
